import React, { useState, useEffect } from 'react';
import { Button } from 'antd';
import { useSearchParams } from 'react-router-dom';
import DOLayout from '../../components/directOrders/DOLayout';
import OrdersExplorer from '../../components/directOrders/OrdersExplorer';
import DirectOrderViewModal from '../../components/DirectOrderViewModal';
import DirectOrderEditModal from '../../components/DirectOrderEditModal';
import { useDirectOrder } from '../../context/DirectOrderContext';
import { useAuth } from '../../context/AuthContext';
import { getOrderStatus } from '../../utils/directOrderStatus';

const ViewDirectOrder = () => {
  const { loadUserDirectOrders, userDirectOrders, loading } = useDirectOrder();
  const { user } = useAuth();
  const [selectedDirectOrder, setSelectedDirectOrder] = useState(null);
  const [editOrder, setEditOrder] = useState(null);

  // Only these users may edit orders that are already approved
  const canEditApproved =
    user?.email === 'claudette.debono-farrugia@festivals.mt' || user?.email === 'zach.zammit@festivals.mt';

  // The overview links here pre-filtered, e.g. ?status=rejected
  const [searchParams] = useSearchParams();
  const requestedStatus = searchParams.get('status');
  const statusFilter = ['pending', 'approved', 'rejected'].includes(requestedStatus) ? requestedStatus : 'all';

  useEffect(() => {
    loadUserDirectOrders();
  }, [loadUserDirectOrders]);

  const renderActions = (order) => {
    const status = getOrderStatus(order);
    return (
      <>
        {status === 'approved' && canEditApproved && (
          <Button type="text" onClick={() => setEditOrder(order)}>
            Edit
          </Button>
        )}
        {status === 'rejected' && (
          <Button type="primary" ghost onClick={() => setEditOrder(order)}>
            Edit and resubmit
          </Button>
        )}
      </>
    );
  };

  return (
    <DOLayout
      title="My orders"
      subtitle="Every direct order you have raised, grouped by festival."
    >
      <OrdersExplorer
        initialGroup={statusFilter}
        orders={userDirectOrders}
        loading={loading}
        onOpen={setSelectedDirectOrder}
        renderActions={renderActions}
        emptyTitle="You haven't raised a direct order yet"
        emptyHint="Start one with New direct order. It will appear here with its approval progress."
      />

      {selectedDirectOrder && (
        <DirectOrderViewModal visible directOrder={selectedDirectOrder} onClose={() => setSelectedDirectOrder(null)} />
      )}
      {editOrder && (
        <DirectOrderEditModal
          visible
          directOrder={editOrder}
          onClose={() => setEditOrder(null)}
          onSave={() => {
            setEditOrder(null);
            loadUserDirectOrders();
          }}
        />
      )}
    </DOLayout>
  );
};

export default ViewDirectOrder;
